import {RESEARCH_DATA} from "@/test/research-data";
import {AUTOMATED_RO_TOP_TABS, AUTOMATED_RESEARCH_TOP_TABS, FEATURES, RO_FEATURES} from "@/utils/constants";

import {dashedCase} from "@/utils/functions";
import {mapActions, mapGetters, mapMutations} from "vuex";

import SubjectPreview from "@/containers/subject-preview";
import Tab from "@/components/tab";
import Loader from "@/components/loader";

import {startCase} from "lodash";
import _ from "lodash";
import {getPlatformURL, getPlatformRedirectURL, getSocialProfileIcon} from "@/utils/functions";
import "@/assets/css/multiselect.scss";

import titleMixin from "@/mixins/titleMixin";
import EntitySelector from "@/containers/entity-selector/v2";
import AddNodeModal from "@/containers/add-node-modal";
import Vue from "vue";
import VTooltip from "v-tooltip";

import DropdownMenuBtn from "@/components/dropdownMenuBtn";
import AnalysisTools from "./../analysisTools";
import DatePicker from "vue2-datepicker";
import CkEditorModal from "@/components/ck-editor-modal";
import NLPAnalysisToolModal from "@/components/nlp-analysis-tool-modal";
import analyseModal from "@/components/analyse/analyseModal";
import scoreboard from "@/components/scoreboard";
import intelligenceModal from "@/components/intelligence";
import axios from "@/axios";
import defaultAxios from "axios";
import MediaClipboardTable from "@/components/media-clipboard-table";
import OutputClipboardTable from "@/components/output-clipboard-table";
import caseSettings from "@/components/caseSettings";

Vue.use(VTooltip);
// import NlpAnalysisFacade, { highlightCaseIdentifiers, highlightNegativeWords, highlightProductWords, NLPAnalysisScriptInit } from "@/utils/content-scripts/nlp-analysis.facade";
// import NLPAnalysisCollection from "@/utils/content-scripts/nlp-analysis.collection";
import KeywordsSelectorToolModal from "@/components/keywords-selector-tool/keywords-selector-tool-modal";

// Dynamic imports for components that are not used on first load
const NeoKeyFacts = () => import("@/containers/key-facts-tab");
const SidePanel = () => import("@/containers/sidepanel");
const docBrowser = () => import("@/containers/docbrowser");
const ManualMonitoringLinkItem = () => import("@/containers/manualMonitoringLinkItem");
const OsintSourcesTab = () => import("@/containers/osint-sources-tab");
const ManualMonitoringModel = () => import("@/containers/manual-monitoring");
const IntelligenceCycleModel = () => import("@/containers/intelligence-cycle-model");
const AddEntityPanel = () => import("@/containers/add-entity-panel");
const Button = () => import("@/components/button");
const Dropdown = () => import("@/components/dropdown");
const Input = () => import("@/components/input");
const ModalResearch = () => import("@/components/modal-research");
const ModalAddContent = () => import("@/components/modal-add-content");
const ModalAllContent = () => import("@/components/modal-all-content");
const ModalReport = () => import("@/components/modal-report");
const Checkbox = () => import("@/components/checkbox");
const Radios = () => import("@/components/radios");
const GenericModal = () => import("@/components/genericModal");
const Toggle = () => import("@/components/toggle");
const OsintGraph = () => import("@/components/osint-graph");
const MultiAccordian = () => import("@/components/multilevel-accordian");
const NeoTools = () => import("./../tools");
const NeoSources = () => import("@/views/sources");
const NeoEntities = () => import("@/views/cases/entities");
const ErrorMessage = () => import("@/components/server-error-message");
const neoDvCard = () => import("@/components/neo-dv-card");

import {EventBus} from "@/main.js";

export default {
    name: "research",
    components: {
        docBrowser,
        // Multiselect,
        MultiAccordian,
        AddEntityPanel,
        "media-clipboard-table": MediaClipboardTable,
        "output-clipboard-table": OutputClipboardTable,
        "neo-button": Button,
        "nlp-analysis-tool-modal": NLPAnalysisToolModal,
        "neo-radios": Radios,
        "analyse-modal": analyseModal,
        "neo-intelligence": intelligenceModal,
        "neo-dropdown": Dropdown,
        "neo-input": Input,
        "neo-tab": Tab,
        "neo-loader": Loader,
        "neo-subject-preview": SubjectPreview,
        "neo-sidepanel": SidePanel,
        "neo-generic-modal": GenericModal,
        "neo-checkbox": Checkbox,
        "neo-anylist": ModalResearch,
        ManualMonitoringLinkItem,
        "neo-osint-sources": OsintSourcesTab,
        "neo-toggle": Toggle,
        "neo-manual-monitoring": ManualMonitoringModel,
        "intelligence-model": IntelligenceCycleModel,
        "add-node-modal": AddNodeModal,
        // "company-methodology": CompanyMethodology,
        "neo-sources": NeoSources,
        "neo-entities": NeoEntities,
        "neo-dropdown-menu-btn": DropdownMenuBtn,
        "analysis-tools": AnalysisTools,
        "neo-datepicker": DatePicker,
        "neo-entity-selector": EntitySelector,
        NeoTools,
        OsintGraph,
        NeoKeyFacts,
        CkEditorModal,
        "neo-scoreboard": scoreboard,
        "neo-case-permissions": caseSettings,
        "keywords-selector-tool-modal": KeywordsSelectorToolModal,
        ErrorMessage,
        neoDvCard,
    },
    mixins: [titleMixin],
    title() {
        return `${this.$route.params.id}`;
    },
    props: ["readOnly"],
    data() {
        return {
            isPermission: false,
            isAuthenticated: false,
            isLoading: false,
            cardsLoading: false,
            topScroll: 0,
            currentPage: 1,
            graphNodes: [],
            graphLinks: [],
            searchResults: {},
            comparatorInputValue: 100,
            currentLocation: null,
            analystOldView: false,
            showReportTemplatesModal: false,
            showHistoryNotesModal: false,
            loadingTemplates: false,
            templates: [],
            isHeader: true,
            isFooter: true,
            templateTabs: [
                {
                    key: "reportTemplates",
                    name: "Report Templates",
                    enabled: true,
                    readOnly: true,
                },
                {
                    key: "iconsData",
                    name: "Icons",
                    enabled: true,
                    readOnly: true,
                },
            ],
            currentTemplateTab: "reportTemplates",
            selectedButton: "",
            buttonOptions: [
                // {
                //     text: "Toolkit",
                //     value: "toolkit1",
                //     popout: true,
                //     clickAction: this.toolkit1,
                // },
                {
                    text: "History & Notes",
                    value: "history_notes",
                    clickAction: this.showHistoryNotes,
                },
                {
                    text: "Create Report",
                    value: "create_report",
                    clickAction: this.createReport,
                },
                // {
                //     text: "Manual Monitoring",
                //     value: "manual_monitoring",
                //     clickAction: this.manualMonitor,
                // },
                // {
                //     text: "Publish to Dashboard",
                //     value: "send_kibana",
                //     clickAction: this.sendToKibana,
                // },
                {
                    text: "File Manager",
                    value: "file_manager",
                    clickAction: this.openFileManagerScreen,
                },
                {
                    text: "Report Templates",
                    value: "report_templates",
                    clickAction: this.reportTemplates,
                },

                {
                    text: "Scoreboard",
                    value: "score_board",
                    clickAction: this.scoreBoardModal,
                },
                {
                    text: "Case Settings",
                    value: "case_settings",
                    clickAction: this.goToCaseSettings,
                },
                {
                    text: "Freeze Case",
                    subtext: true,
                    value: "freeze_case",
                    clickAction: this.freezeCase,
                },
                {
                    text: "Restore Case",
                    value: "restore_case",
                    clickAction: () => this.$modal.show("restore_case"),
                },
                {
                    text: "NLP analysis tool",
                    value: "nlp_analysis_tool",
                    clickAction: () => this.$modal.show("nlp-analysis-tool-modal"),
                },
            ],
            readOnlyButtonOptions: [
                // {
                //     text: "History & Notes",
                //     value: "history_notes",
                //     clickAction: this.showHistoryNotes,
                // },
                {
                    text: "File Manager",
                    value: "file_manager",
                    clickAction: this.openFileManagerScreen,
                },
                // {
                //     text: "NLP analysis tool",
                //     value: "nlp_analysis_tool",
                //     clickAction: () => this.$modal.show("nlp-analysis-tool-modal"),
                // },
            ],
            addNode: false,
            showIntelligenceCycle: false,
            paginating: false,
            showNotes: false,
            manualMonitoring: [
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
                {
                    url: "https://pinkmedia.org",
                    lastChecked: "19-01-2920",
                    nextCheck: "22-01-2920",
                    duration: 12,
                },
            ],
            showModal: false,
            associated_value: "",
            removedEntity: ["associated_entity", "social_profile", "volunteering_roles", "wider_evidence_skills", "charitable_work", "active_media", "search", "passive_media"],
            entityData: [],
            filteredEntitydata: [], //for filtering personal details based on entity filter
            activePassiveMediaMonitoringCheckbox: false,
            date_type: "0",
            icons: [],
            content_type: "",
            allDataFetched: false,
            errors: [],
            data: RESEARCH_DATA,
            isPanelOpen: false,
            currentZoom: 1,
            case_id: "",
            graph: null,
            showGraph: false,
            panelType: "",
            currentTopTab: this.$route.name,
            top_tabs: AUTOMATED_RESEARCH_TOP_TABS,
            ro_top_tabs: AUTOMATED_RO_TOP_TABS,
            user: {
                displayName: "Thomas Blake1",
                email: "thomasblake@gmail.com",
                phone: "+1 233 342 2345",
            },
            queriesExpand: false,
            sourcesExpand: false,
            domainsExpand: false,
            filterControls: {
                status: [],
                riskCategories: [],
                confidenceScore: [],
                identifiersCount: [],
                identifiersMatched: [],
                identifiersInputs: [],
                identifiersTools: [],
                persons: [],
                locations: [],
                organisations: [],
                categories: [],
                social_platform: [],
                media_type: [],
                monitoring: false,
                entityFilter: [],
                selectedCaseUser: [],
                startDate: null,
                endDate: null,
            },
            // activePassiveMediaSortingByPublishedDate: "Newest to Oldest",
            // activePassiveMediaOptionsKey: "Media type",
            // activePassiveMediaSortByDateKey: "Sort By Published Date",
            // activePassiveMediaSortByDateOptions: ["Newest to Oldest","Oldest to Newest"],
            loader: null,
            searchFilterTypes: ["All", "Not Done", "Done"],
            infoCard: {},
            lastShowNotesValue: false,
            expandedAnalysisGraph: null,
            counterInterval: null,
            isKeyFactLoading: false,
            bothExtensionChecked: false,
            showCasePermissions: false,
            case_status: "In Progress",
            restoringCase: false,
            selectedResearchTab: null,
            intelligenceRunning: false,
            nerRunning: false,
            fetchingTabs: false,
            showGraphDrawer: false,
            showFiltersDrawer: false,
            personalDetailsTabs: ["name", "email", "location", "address", "education", "employment", "phone", "hobby", "website", "domain", "event", "username"],
            toastId: null,
            allFilterParams: [],
            progress: 5,
            listView: false,
            topicCategories: [],
            outputFilters: ["status", "rag_status", "riskCategories", "identifiersCount", "identifiersMatched", "identifiersInputs", "identifiersTools", "persons", "locations", "organisations", "confidenceScore", "categories", "selectedCaseUser", "startDate", "endDate", "social_platform"],
        };
    },
    watch: {
        fetchCurrentTopTab() {
            this.fetchCurrentTopTab === "research-automated" ? (document.title = `${this.$route.params.id} | Neotas`) : "";
        },

        search() {
            this.refreshResearchScreen();
        },
    },
    filters: {
        capitalize: function(value) {
            if (!value) return "";
            return value
                .split("_")
                .map((val) => {
                    return val.charAt(0).toUpperCase() + val.slice(1);
                })
                .join(" ");
        },
    },
    computed: {
        ...mapGetters([
            "getSelectedEntityData",
            "isAddEntityPanelOpen",
            "getCompanyProducts",
            "getReadOnlyMode",
            "getResearchData",
            "getConfirmedCount",
            "getConfirmed",
            "getIrrelevantCount",
            "getIrrelevant",
            "getFiltersApplied",
            "getPersonalDetails",
            "getCaseId",
            "getSearchFilters",
            "getActiveSearchFilters",
            "getExtraContent",
            "getOriginalCaseData",
            "getInvalidCaseId",
            "getCaseUsers",
            "getLastReviewed",
            "getAuthDetails",
            "getCasePersonalData",
            "checkIsUserManagedCase",
            "getUserAuthDetails",
            "getIsUserAdmin",
            "getCaseFreezeDate",
            "getCaseStatus",
            "getFilteredData",
            "overallToolsStatus",
            "getSocketIO",
            "getPermissions",
            "checkPermissionsFetched",
            "caseValid",
            "getProduct",
            "getEntitiesRelationsAttributesData",
            "getCaseResearchTabs",
            "getCaseResearchData",
        ]),

        isResearchEnabled() {
            // if (this.isManagedCase) {
            //     return (this.isCaseStateDone || this.isCaseStateMonitoring) ? true: false;
            // } else
            return this.getCaseId !== "NEW" ? true : false;
        },

        isManagedCase() {
            return !this.$store.getters.checkIsUserManagedCase ? true : false;
        },

        isCaseStateDone() {
            return this.$store.getters.getCaseStatus?.toLowerCase() == "done";
        },

        isCaseStateMonitoring() {
            return this.$store.getters.getCaseStatus?.toLowerCase() === "monitoring";
        },

        isResearchScreen() {
            return this.isResearchEnabled && !this.$route.name.includes("entities");
        },

        isNeotasUser() {
            return this.getUserAuthDetails.email.includes("@neotas.com");
        },

        currentEntityTab() {
            return this.isManagedCase ? this.$route.name.split("entities-")[1] : "";
        },

        entities() {
            return this.filterControls.entityFilter;
        },

        caseIdentifiersChecked: function() {
            return this.$store.getters.getCaseIdentifiersChecked;
        },
        badWordsChecked: function() {
            return this.$store.getters.getBadWordsChecked;
        },
        productKeywordsChecked: function() {
            return this.$store.getters.getProductKeywordsChecked;
        },
        getLastPublished() {
            let doc = {
                updated_by: this.getCasePersonalData.job_update.updated_by,
            };
        },
        getActiveEntity() {
            return this.$store.getters.getFiltersApplied.entityFilter;
        },

        monitoringLink() {
            return `https://kibana.neotas.uk:5601/s/channel-capital/app/kibana#/dashboard/f339ea60-39f2-11eb-a5db-d1bfaf9daf87?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1y,to:now))&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'19cd6ec0-39f0-11eb-a5db-d1bfaf9daf87',key:orca_id.keyword,negate:!f,params:(query:${this.$store.getters.getCaseId}),type:phrase),query:(match_phrase:(orca_id.keyword:${this.$store.getters.getCaseId})))))`;
        },
        getGridColumns() {
            return "repeat(auto-fill, minmax(30rem, 1fr))";
        },
        activeTab() {
            if (this.currentTab !== "personalDetails") return this.getActiveTab(this.currentTab);
        },

        showLoadMoreButton() {
            let cards = document.getElementById("social-media-automation")?.childElementCount;
            return cards?.length && this.filtered.length < this.selectedTab.total_count;
        },

        filtered() {
            let cards = [];
            if (this.currentTab !== "map") {
                cards = this.$store.getters.getCaseResearchData?.[this.currentTab];
            }
            return cards;
        },

        selectedTab() {
            const selectedTab = this.tabs?.find((tab) => tab._id === this.selectedResearchTab._id);
            return selectedTab;
        },

        tabs() {
            let navTabs = this.getCaseResearchTabs.filter((el) => !this.removedEntity.includes(el.key) && el.enable);
            // const entityData = this.entities.length == 1 && this.getEntitiesRelationsAttributesData?.entities.find((n) => n._id == this.entities[0]?.entity_type?._id);
            // if (entityData) {
            //     const stateNames = navTabs.filter((n) => n?.entity_type?.find((e) => e.entity_id == entityData.parent_id));
            //     navTabs = stateNames;
            // }
            let tabs = [...navTabs];
            tabs = tabs
                .map((ele) => {
                    if (["associatedPeople", "media", "socialProfiles", "keyFacts"].includes(ele.key))
                        return {
                            ...ele,
                        };
                    else
                        return {
                            ...ele,
                            tab_key: ele.key,
                        };
                })
                .filter((ele) =>
                    this.getPermissions.find((ele1) => {
                        if (["associatedPeople", "media", "socialProfiles", "keyFacts"].includes(ele.key)) return FEATURES[ele1] == ele.key;
                        else return FEATURES[ele1] == "personalDetails";
                    })
                );
            return tabs;
        },

        intelligenceTabs() {
            return this.tabs.filter((tab) => ["name", "username", "email", "phone", "socialProfiles", "associatedPeople"].includes(tab.key));
        },

        filtersCount() {
            let counter = 0;
            for (const filter in this.filterControls) {
                const value = this.filterControls[filter];
                if (this.outputFilters.includes(filter) && value?.length) counter += 1;
            }
            return counter;
        },

        options() {
            if (this.readOnly) {
                return {
                    riskCategories: this.$store.getters.getRiskCategories,
                    identifiersCount: [
                        {
                            group: "Identifiers Count",
                            values: [
                                {
                                    label: "1",
                                    value: 1,
                                },
                                {
                                    label: "2",
                                    value: 2,
                                },
                                {
                                    label: "3",
                                    value: 3,
                                },
                                {
                                    label: "4",
                                    value: 4,
                                },
                                {
                                    label: "5",
                                    value: 5,
                                },
                                {
                                    label: "6+",
                                    value: 6,
                                },
                            ],
                        },
                    ],
                    confidenceScore: [
                        {
                            group: "Confidence Score",
                            values: ["High", "Medium", "Low"],
                        },
                    ],
                    identifiersMatched: [
                        {
                            group: "Identifiers",
                            values: this.matchingIdentifier,
                        },
                    ],
                    identifiersInputs: [
                        {
                            group: "Identifier Inputs",
                            values: this.identifierInputs,
                        },
                    ],
                    identifiersTools: [
                        {
                            group: "Identifier Tools",
                            values: this.identifierTools,
                        },
                    ],
                    persons: [
                        {
                            group: "Persons",
                            values: this.allFilterParams?.persons?.filter((el) => el) || [],
                        },
                    ],
                    locations: [
                        {
                            group: "Locations",
                            values: this.allFilterParams?.locations?.filter((el) => el) || [],
                        },
                    ],
                    organisations: [
                        {
                            group: "Organisations",
                            values: this.allFilterParams?.organisations?.filter((el) => el) || [],
                        },
                    ],
                    categories: this.topicCategories,
                    social_platform: this.$store.getters.getSocialPlatforms.map((prof) => prof.key).map(startCase),
                    media_type: ["Media", "URL"],
                    // sortBy: [...SORT_OPTIONS],
                };
            } else {
                return {
                    status: [{group: "Status", values: ["confirmed", "potential", "None"].map(startCase)}],
                    rag_status: [{group: "Rag Status", values: ["red", "amber", "green"].map(startCase)}],
                    riskCategories: this.$store.getters.getRiskCategories,
                    identifiersCount: [
                        {
                            group: "Identifiers Count",
                            values: [
                                {
                                    label: "1",
                                    value: 1,
                                },
                                {
                                    label: "2",
                                    value: 2,
                                },
                                {
                                    label: "3",
                                    value: 3,
                                },
                                {
                                    label: "4",
                                    value: 4,
                                },
                                {
                                    label: "5",
                                    value: 5,
                                },
                                {
                                    label: "6+",
                                    value: 6,
                                },
                            ],
                        },
                    ],
                    confidenceScore: [
                        {
                            group: "Confidence Score",
                            values: ["High", "Medium", "Low"],
                        },
                    ],
                    identifiersMatched: [
                        {
                            group: "Identifiers",
                            values: this.matchingIdentifier,
                        },
                    ],
                    identifiersInputs: [
                        {
                            group: "Identifier Inputs",
                            values: this.identifierInputs,
                        },
                    ],
                    identifiersTools: [
                        {
                            group: "Identifier Tools",
                            values: this.identifierTools,
                        },
                    ],
                    persons: [
                        {
                            group: "Persons",
                            values: this.allFilterParams?.persons?.filter((el) => el) || [],
                        },
                    ],
                    locations: [
                        {
                            group: "Locations",
                            values: this.allFilterParams?.locations?.filter((el) => el) || [],
                        },
                    ],
                    organisations: [
                        {
                            group: "Organisations",
                            values: this.allFilterParams?.organisations?.filter((el) => el) || [],
                        },
                    ],
                    categories: this.topicCategories,
                    social_platform: this.$store.getters.getSocialPlatforms.map((prof) => prof.key).map(startCase),
                    media_type: ["Media", "URL"],
                    // sortBy: [...SORT_OPTIONS],
                };
            }
        },

        identifierInputs() {
            return this.allFilterParams?.inputs?.filter((el) => el) || [];
            // let data = [];
            // this.filtered?.forEach((card) => {
            //     for (let index in card.identifier_inputs) {
            //         data = data.concat(Object.values(card.identifier_inputs[index]))
            //     }
            // })
            // return _.uniq(data.filter((el) => el))
        },
        matchingIdentifier() {
            return this.allFilterParams?.matching_identifiers?.filter((el) => el) || [];
            // let data = [];
            // this.filtered?.forEach((card) => {
            //     for (let index in card.identifiers) {
            //         delete card.identifiers[index]?.platform;
            //         data = data.concat(Object.values(card.identifiers[index]))
            //     }
            // })
            // return _.uniq(data.filter((el) => el))
        },
        identifierTools() {
            return this.allFilterParams?.tools?.filter((el) => el) || [];
            // let data = [];
            // this.filtered?.forEach((card) => {
            //     for (let index in card.identified_source) {
            //         data = data.concat(Object.values(card.identified_source[index]))
            //     }
            // })
            // return _.uniq(data.filter((el) => el))
        },

        getFilterPayload() {
            return {
                status: this.filterControls.status?.map((el) => {
                    if (el === "None") return null;
                    else return el.toUpperCase();
                }),
                rag_status: this.filterControls.rag_status,
                risk_categories: this.filterControls.riskCategories.map((el) => el.category),
                identifiers: this.filterControls.identifiersCount.map((el) => el.value),
                identifiersMatched: this.filterControls.identifiersMatched,
                identifiersInputs: this.filterControls.identifiersInputs,
                identifiersTools: this.filterControls.identifiersTools,
                persons: this.filterControls.persons,
                locations: this.filterControls.locations,
                organisations: this.filterControls.organisations,
                confidenceScore: this.filterControls.confidenceScore,
                categories: this.filterControls.categories,
                user: this.filterControls.selectedCaseUser.map((el) => el.id),
                entity: this.filterControls.entityFilter.map((el) => el._id),
                startDate: this.filterControls.startDate,
                endDate: this.filterControls.endDate,
                media_type: this.filterControls.media_type.map((el) => el.toLowerCase()),
                social_platform: this.filterControls.social_platform.map((el) => el.toLowerCase()),
                global_search: this.$store.getters.search?.["research-automated"],
                monitoring: this.activePassiveMediaMonitoringCheckbox,
                current_page: this.currentPage,
                limit: 50,
            };
        },

        irrelevantCount() {
            let count = 0;

            for (const [tab, tabData] of Object.entries(this.getIrrelevant)) {
                if (tab === "personalDetails") {
                    tabData.forEach((item) => {
                        if (item.item && item.item.entity_identifier) {
                            if (this.removedEntity.includes(item.item.entity_identifier)) {
                                count += 1;
                            }
                        }
                    });
                }
            }
            return this.getIrrelevantCount - count + this.getExtraContent.filter((n) => n.deleted).length;
        },
        fetchCurrentTopTab() {
            return this.$route.name;
        },
        currentTab() {
            let tab = this.$route.params.casename;
            this.showGraph = tab == "map" ? true : false;
            let currentTab;
            if (tab && this.tabs.find((n) => n.key === tab)) {
                currentTab = tab;
            } else {
                currentTab = this.$route.params.casename || "socialProfiles";
            }
            return currentTab;
        },
        async search() {
            return this.$store.getters.search?.["research-automated"];
        },

        get_top_tabs() {
            let tabs = this.top_tabs
                .map((key) => {
                    if (key.key === "research")
                        return {
                            ...key,
                            key: "research-automated",
                        };
                    else return key;
                })
                .filter(({key}) => {
                    if (key === "research-automated") return this.isShowResearchTab;
                    else if (key.includes("entities")) return true;
                    else {
                        return this.getPermissions.find((ele1) => FEATURES[ele1] == key);
                    }

                    // else if (key === "methodology") {
                    //     return this.getPermissions.includes("methodology__methodology");
                    // } else if (key === "sources") {
                    //     return this.getPermissions.includes("sources__sources");
                    // }
                });
            if (this.isResearchEnabled) {
                if (this.isManagedCase) return tabs;
                else return tabs.filter((el) => !el.key.includes("entities"));
            } else {
                if (this.isManagedCase) {
                    if (!this.isNeotasUser)
                        tabs = tabs.map((el) => {
                            if (el.key === "entities-output")
                                return {
                                    ...el,
                                    ...{disabled: true},
                                };
                            else return el;
                        });
                    return this.getCaseId !== "NEW" ? tabs : tabs.filter((el) => el.key.includes("entities"));
                }
            }
        },

        get_ro_top_tabs() {
            let tabs = this.ro_top_tabs
                .map((key) => {
                    if (key.key === "research")
                        return {
                            ...key,
                            key: "research-automated",
                        };
                    else return key;
                })
                .filter(({key}) => {
                    if (key === "research-automated") return this.isShowResearchTab;
                    else if (key === "methodology-ro") return this.getPermissions.includes("methodology__methodology");
                    else if (key.includes("entities")) return true;
                    else {
                        // removed permission check from RO TABS FOR NOW AS TECH-4296
                        // return this.getPermissions.find((perm) => RO_FEATURES[perm] == key);
                    }
                });

            if (this.isResearchEnabled) {
                if (this.isManagedCase) return tabs;
                else return tabs.filter((el) => !el.key.includes("entities"));
            } else {
                if (this.isManagedCase) {
                    if (!this.isNeotasUser)
                        return tabs.map((el) => {
                            if (el.key === "entities-output")
                                return {
                                    ...el,
                                    ...{disabled: true},
                                };
                            else return el;
                        });
                    return this.getCaseId !== "NEW" ? tabs : tabs.filter((el) => el.key.includes("entities"));
                }
            }
        },

        permissionsFetched() {
            return this.checkPermissionsFetched;
        },
        isAuth() {
            if (["associatedPeople", "media", "socialProfiles", "keyFacts"].includes(this.currentTab)) return this.getPermissions.some((ele) => FEATURES[ele] == this.currentTab);
            else return this.getPermissions.some((ele) => FEATURES[ele] == "personalDetails");
        },

        isAnalyzerAuth() {
            return this.getPermissions.includes("analyzer__entity_recognition") && this.getPermissions.includes("analyzer__core_risk_categorisation") && this.getPermissions.includes("analyzer__topic_classification") && this.getPermissions.includes("analyzer__esg_categorisation");
        },
        isSuperUser() {
            // let userRoles = this.getUserAuthDetails.userRole.split(",");
            // return userRoles.includes("SuperVisor");
            return this.getIsUserAdmin;
        },
        isAssociationGraphAuth() {
            return this.getPermissions.includes("association_graph__case_data");
        },
        isSocialMediaAuth() {
            return this.getPermissions.includes("social_media_automation__social_media");
        },
        getButtonOptions() {
            // [
            //     {
            //         text: "History & Notes",
            //         value: "history_notes",
            //         clickAction: this.showHistoryNotes,
            //     },
            //     {
            //         text: "Create Report",
            //         value: "create_report",
            //         clickAction: this.createReport,
            //     },
            //     {
            //         text: "File Manager",
            //         value: "file_manager",
            //         clickAction: this.openFileManagerScreen,
            //     },
            //     {
            //         text: "Report Templates",
            //         value: "report_templates",
            //         clickAction: this.reportTemplates,
            //     },
            //     {
            //         text: "Scoreboard",
            //         value: "score_board",
            //         clickAction: this.scoreBoardModal,
            //     },
            //     {
            //         text: "Case Settings",
            //         value: "case_settings",
            //         clickAction: this.goToCaseSettings,
            //     },
            // ],
            let userRoles = this.getUserAuthDetails?.userRole;
            let buttonOptions = this.buttonOptions.filter((ele) => {
                if (ele.value === "nlp_analysis_tool") {
                    return true;
                }
                if (ele.value === "report_templates" || ele.value === "create_report") {
                    return this.getPermissions.includes("reports_related_features__case_data");
                } else if (ele.value === "case_settings") {
                    return true;
                } else if (ele.value === "freeze_case") {
                    return userRoles?.includes("case_freeze");
                } else if (ele.value === "restore_case") {
                    return userRoles?.includes("case_freeze") && this.getCaseFreezeDate;
                } else {
                    return this.getPermissions.find((ele1) => FEATURES[ele1] == ele.value);
                }
            });
            const index = buttonOptions.findIndex((el) => el.value === "freeze_case");
            if (this.getCaseFreezeDate && index > 0) {
                buttonOptions[index].text = "Case Frozen";
            }
            return buttonOptions;
        },
        getReadOnlyButtonOptions() {
            const readOnlyButtonOptions = this.readOnlyButtonOptions;
            // debugger;
            // .filter((ele) => this.getPermissions.find((ele1) => FEATURES[ele1] == ele.value));
            return readOnlyButtonOptions;
        },
        isEntitiesAuth() {
            return this.getPermissions.includes("detail_section__case_data") || this.getPermissions.includes("associated_entities__case_data");
        },
        isShowResearchTab() {
            const researchTabs = ["outputs__case_data", "detail_section__case_data", "social_profiles__case_data", "associated_entities__case_data", "media__case_data"];
            return this.getPermissions.some((permission) => researchTabs.includes(permission));
        },

        product_data() {
            return this.getCompanyProducts.find((prod) => prod.name === this.getCasePersonalData?.data?.["Due Diligence Level"]?.value);
        },
    },

    async created() {
        await this.$store.dispatch("setCaseId", this.$route.params.id);
        // let lc = location.hash.replace("#", "");
        // if (lc.length >= 1 && (Object.keys(VALID_TAB_LOCATIONS).includes(lc) || lc === "map")) {
        //     if (lc === "map") {
        //         this.showGraph = true;
        //         this.currentLocation = lc;
        //     } else {
        //         this.currentTab = lc;
        //         this.currentLocation = lc;
        //     }
        // } else {
        //     this.currentTab = DEFAULT_ACTIVE_TAB;
        // }
        this.$store.dispatch("setReadOnly", this.readOnly);
        this.filterControls.entityFilter = this.$store.getters.getFiltersApplied?.entityFilter ?? [];

        await this.socketIOConn();
        // await this.fetchPermissions();
        EventBus.$on("handleCopyToTable", (data) => {
            this.handleCopyToTable(data.tab, data.list);
        });
        EventBus.$on("refreshData", () => {
            this.refreshData();
        });
        EventBus.$on("refreshResearchScreen", async () => {
            await this.refreshResearchScreen();
            await this.fetchAllResearchScreenData({currentTab: "personalDetails"});
        });
        EventBus.$on("more", (data) => {
            this.onMoreDetails(data);
        });
    },

    async mounted() {
        // const validationResponse = await axios.get(`/case-data/${this.$route.params.id}/validate`);
        // this.top_tabs.map(tab => tab.hideInRO = this.getReadOnlyMode)
        if (this.$store.getters.getCaseId != "NEW") {
            await this.getCaseCurrentStatus();
        } else this.isAuthenticated = true;
        if (this.caseValid && this.isResearchEnabled) {
            if (this.currentTab !== "map") {
                this.$store.dispatch("fetchStaticData");
                await this.fetchCasePersonalData();
            }
            await this.handleCaseResearchTab();

            try {
                this.isLoading = true;
                await this.fetchAnalysisTools();
                await this.fetchCompanyProducts(); // Function to fetch company related products
                await this.fetchAllResearchScreenData({currentTab: "personalDetails"});

                this.allDataFetched = true;
                this.isLoading = false;
            } catch (err) {
                console.error(err, "oops");
            }

            let tab;
            if (this.getReadOnlyMode) tab = this.ro_top_tabs.find((tab) => tab.key === "research");
            else tab = this.top_tabs.find((tab) => tab.key === "research");
            tab.name = "Case ID: " + this.$store.getters.getCaseId;
            this.redirectToMoreInfo();
            this.connectToExtension(this.$store.state.research.extensionID);

            await this.getNewMonitoringEvents(); // Function to get new monitoring events on product and case level
        }
    },
    beforeDestroy() {
        EventBus.$off("handleCopyToTable");
        EventBus.$off("refreshData");
        EventBus.$off("refreshResearchScreen");
        EventBus.$off("more");
    },

    methods: {
        getPlatformURL,
        getPlatformRedirectURL,
        getSocialProfileIcon,
        ...mapActions(["fetchCompanyProducts", "getNewMonitoringEvents", "setFilter", "filterData", "pushConfirmed", "popConfirmed", "pushIrrelevant", "popIrrelevant", "fetchResearchData", "fetchHistory", "fetchAllResearchScreenData", "fetchAnalysisTools", "getToolsStatus", "createSocketIOConn", "fetchPermissions", "getAllResearchTabs", "getAllResearchData", "fetchCasePersonalData"]),
        ...mapMutations(["SET_EXTENSION_ID", "set_search"]),
        return() {
            return 0;
        },

        setCaseStatus(case_status) {
            this.case_status = case_status;
        },

        async closeMoreInfo(ref) {
            if (ref) {
                if (ref.$refs?.["more-info-automated"]) ref.$refs["more-info-automated"].loadingBtn = false;
                ref.closeMoreInfo();
            }
            await this.refreshResearchScreen();
            await this.fetchAllResearchScreenData({currentTab: "personalDetails"});
        },

        connectToExtension(extensionID) {
            try {
                if (window.chrome) {
                    chrome.runtime.sendMessage(
                        extensionID,
                        {
                            msg: "externalSetCaseID",
                            case_id: this.$store.getters.getCaseId,
                        },
                        ({status}) => {
                            if (status === "ok" || status === "skip") {
                                this.SET_EXTENSION_ID(extensionID);
                            }
                        }
                    );
                }
            } catch (error) {
                if (!this.bothExtensionChecked) {
                    this.bothExtensionChecked = true;
                    this.connectToExtension(this.$store.state.research.externalExtensionID);
                }
            }
        },

        async handleResearchTab(tab) {
            this.selectedResearchTab = tab;
            await this.refreshData();
            this.onTabChange(tab.key);
        },

        openCustomReportTemplateEditor() {
            this.$router.push({path: "/editor"});
        },
        toggleGraphDrawer(event) {
            // this.osintGraphDrawerOpen = !this.osintGraphDrawerOpen;
            // window.networkx.redraw();

            this.handleGraphExpansion(
                {
                    val: event,
                    key: true,
                },
                this.fetchCurrentTopTab !== "tools" && this.fetchCurrentTopTab !== "tools-ro" ? true : false
            );
            // this.toggleAnalyzer = false;
        },

        filterOnLastSendDate() {
            this.filterControls.startDate = this.getCasePersonalData.job_update.timestamp;
            this.handelUserFilter();
        },
        clickAction(clickEvent, event) {
            return clickEvent();
        },
        toolkit1() {
            window.open(`https://toolkit.neotas.uk:8443/app/toolkit/?caseid=${this.$store.getters.getCaseId}&new=1`, "_blank");
        },
        toolkit2() {
            window.open("https://toolkit.neotas.uk:8443/app/skype/", "_blank");
        },
        showHistoryNotes() {
            this.showHistoryNotesModal = true;
        },
        manualMonitor() {
            this.showModal = true;
        },
        scoreBoardModal() {
            this.$modal.show("scoreboard");
        },
        goToCaseSettings() {
            // this.$router.push({
            //     path: "/case/configure",
            //     query: {
            //         product: this.getCasePersonalData?.data["Due Diligence Level"]?.value,
            //         case_id: this.$store.getters.getCaseId,
            //     },
            // });
            this.showCasePermissions = true;
            // this.$router.push({ name: "caseSettings" });
        },
        async getCaseCurrentStatus() {
            this.isPermission = true;
            try {
                const response = await axios.get(`/case-data/case-current-state/${this.$store.getters.getCaseId}`);
                this.isAuthenticated = true;
                this.isPermission = false;
            } catch (error) {
                if (error.response.status === 401 && error.response.data.detail.includes("Unauthorized")) {
                    this.isAuthenticated = false;
                    this.isPermission = false;
                } else {
                    let message = error.message;
                    this.$toast.error(message);
                    this.isAuthenticated = false;
                    this.isPermission = false;
                }
            }
        },
        async freezeCase() {
            const payload = {
                case_id: this.getCaseId,
            };
            const {data} = await axios.post(`/case-data/case-state`, payload);
            if (data?.status) this.$toast.success("Case Frozen");
        },
        async restoreCase() {
            this.restoringCase = true;
            const {data} = await axios.get(`/case-data/case-state/${this.getCaseId}`);
            if (data?.status) {
                this.$toast.success("Case Restored");
                location.reload();
            }
        },
        closeCasePermissions() {
            this.showCasePermissions = false;
        },
        async sendToKibana() {
            let data = {
                updated_by: this.$store.getters.getAuthDetails?.username,
            };
            let response = await axios.post(`/continuous-monitoring-items/${this.$store.getters.getCaseId}/send-to-kibana`, data);
            if (response && response.data) {
                this.$toast.success("Published to dashboard");
            } else {
                this.$toast.success("Error: Couldn't publish to dashboard");
            }
        },
        openFileManagerScreen() {
            this.$router.push({name: this.getReadOnlyMode ? "docBrowser-ro" : "docBrowser"});
        },
        createReport() {
            this.generatePDF();
            // if (this.$store.getters.getCaseType == "ORCA") this.generatePDF();
            // else if (this.$store.getters.getCaseType == "CS") this.gotoReport();
        },
        async reportTemplates() {
            this.showReportTemplatesModal = true;
            this.loadingTemplates = true;
            try {
                let response = await axios.get(`report-templates-admin/product/${this.$store.getters.getProduct.key}`);
                if (response && response.data) {
                    this.templates = response.data;
                    this.loadingTemplates = false;
                } else {
                    this.loadingTemplates = false;
                }
                let response1 = await axios.get(`report-templates/icons`);
                if (response1 && response1.data) {
                    this.icons = response1.data.icons_data;
                    this.icons.forEach((icon) => {
                        icon.download_url = `${process.env.VUE_APP_REPORTS_URL}/icons/${icon.icon_name}`;
                    });
                }
            } catch (err) {
                console.error(err);
                this.loadingTemplates = false;
            }
        },

        async reportTemplatesDownload(filename) {
            let urlResponse = await axios.get(`report-templates-admin/presigned-url/${filename}`);
            let download_url = urlResponse.data.url;
            const fileLink = document.createElement("a");
            fileLink.href = download_url;
            fileLink.setAttribute("download", "");
            fileLink.click();
        },

        generatePDF() {
            this.$toasted.show("Generating PDF...", {
                duration: 5000,
            });
            defaultAxios.post(`${process.env.VUE_APP_PORTAL_URL}/orca/review/screen/case/${this.$store.getters.getCaseId}`, {createPDF: true}).then((response) => {
                this.$toasted.show("PDF Generated.", {
                    duration: 5000,
                });
                this.$modal.show(
                    ModalReport,
                    {
                        text: "This text is passed as a property",
                        heading: "PDF Report",
                        data: response,
                        datatype: "missing",
                        automated: true,
                    },
                    {
                        name: "report-modal",
                        height: "90%",
                        width: "50%",
                        scrollable: true,
                        styles: {
                            overflow: "none",
                        },
                    },
                    {
                        "before-close": (event) => {},
                    }
                );
            });
        },
        showIntelligenceModal() {
            if (!this.intelligenceRunning && !this.nerRunning) this.$modal.show("run-intelligence");
        },
        async runIntelligence(selectedEntities) {
            this.intelligenceRunning = true;
            this.$modal.hide("run-intelligence");
            const payload = {
                product_name: this.getCasePersonalData?.data["Due Diligence Level"]?.value,
                case_id: this.$store.getters.getCaseId,
                rule_engine_set: this.product_data?.rule_engine_set,
            };
            for (const tab of Object.keys(selectedEntities)) {
                payload[tab] = selectedEntities[tab];
            }
            try {
                let response = await axios.post(`social-media-automation/run-intelligence`, payload, {
                    headers: {
                        "X-Intelligence-Source": "Neotas",
                    },
                });
                if (response && response.status) {
                    this.toastId = this.$toast.info("Running Intelligence !", {
                        timeout: false,
                    });
                    this.checkIntelligenceStatus();
                } else this.$toast.error("Some error occurred, Please try again later");
            } catch (err) {
                console.error(err);
            }
        },

        showHistory() {
            this.$modal.show(
                ModalResearch,
                {
                    text: "This text is passed as a property",
                    heading: "OSINT Intelligence",
                    datatype: "missing",
                },
                {
                    height: "auto",
                    width: "50%",
                    scrollable: true,
                },
                {
                    "before-close": (event) => {},
                }
            );
        },

        getManualMonitoring() {
            this.manualMonitoring = this.filtered
                .filter((el) => {
                    return ["url_page_monitoring", "site_monitoring", "browser_automation"].includes(el?.monitoring_type);
                })
                .map((el) => {
                    return {
                        case_id: el.case_id,
                        id: el._id,
                        url: el.url,
                        lastChecked: "01-01-2021",
                        nextCheck: "10-01-2021",
                        duration: Math.floor(Math.random() * 100) + 1,
                    };
                });
            this.showModal = true;
        },

        onManualMonitoringChange(item) {},
        openReportBuilder() {
            window.location.href = "http://balckbox.neotas.uk:9002";
        },

        gotoReport() {
            this.$router.push({name: "Create Report"});
        },
        closeManualMonitoringModal() {
            this.showModal = false;
        },

        ConsolidateSourceFromTag(sources, type) {
            let data = {children: []};

            sources.forEach((source) => {
                if (source.country && this.osintFilterCountry) {
                    source.country.forEach((country) => {
                        let index = data.children.findIndex((val) => val.text.toLowerCase() === country);

                        if (index >= 0) {
                            data.children[index].children.push({text: source.source});
                        } else {
                            data.children.push({text: country, children: [{text: source.source}]});
                        }
                    });
                }

                if (source.region && this.osintFilterRegion) {
                    source.country.forEach((country) => {
                        let index = data.children.findIndex((val) => val.text.toLowerCase() === country);
                        if (index >= 0) {
                            data.children[index].children.push({text: source.source});
                        } else {
                            data.children.push({text: country, children: [{text: source.source}]});
                        }
                    });
                }
                if (source.type && this.osintFilterType) {
                    source.region.forEach((type) => {
                        let index = data.children.findIndex((val) => val.text.toLowerCase() === type);
                        if (index >= 0) {
                            data.children[index].children.push({text: source.source});
                        } else {
                            data.children.push({text: type, children: [{text: source.source}]});
                        }
                    });
                }
            });

            return data;
        },

        toggleFilter(query) {
            query.active = !query.active;
        },

        filterSearchResults() {
            this.loader = this.$loading.show({
                container: document.querySelector(".cards"),
                canCancel: false,
                color: "#0d69d5",
                loader: "bars",
                blur: "20px",
                opacity: 0.7,
            });
            //this.getActiveSearchFilters.params.append("case_id", this.getCaseId)
            axios.post(`datapoints`, this.getActiveSearchFilters.filter_data).then((x) => {
                this.$store.dispatch("updateSearchResults", x.data);
                this.onChanges();
                this.loader.hide();
            });
        },
        //{ "case_id": "ORCA-b819c2a7ec99", "status": null, "search_queries": [ "\"Anthony James Lees\" \"(DidemnumVex OR Hyderabad OR India OR measures OR India OR India)\"" ], "domains": [], "sources": [] }
        applyFilters() {
            this.filterSearchResults();
        },

        clearFilters() {
            Object.keys(this.getSearchFilters).forEach((e) => {
                this.getSearchFilters[e].forEach((f) => {
                    f["active"] = false;
                });
            });
            this.filterSearchResults();
        },

        openDashboardLink: function() {
            window.open(this.monitoringLink, "_blank");
        },
        entity_one: function(e) {
            let data = this.entityMapper.filter((val) => {
                return val.parentid == e.target.value;
            });
            this.renderSelectOptions(data, "entity_select_two");
        },
        entity_two: function(e) {
            let data = this.entityMapper.filter((val) => {
                return val.parentid == e.target.value;
            });
            this.renderSelectOptions(data, "entity_select_three");
        },
        renderSelectOptions(value, elemId) {
            let child = value;
            let elem = document.getElementById(elemId);
            let option = "<option value=''>Select Child</option>";
            child.forEach(function(childVal) {
                option = option + "<option value=" + childVal["_id"] + ">" + childVal.entity + "</option>";
            });
            elem.innerHTML = option;
            elem.style.display = "block";
        },

        getActiveTab(tab) {
            const whitelist = ["socialProfiles", "websites"].indexOf(tab) > -1;

            return `neo-${whitelist ? dashedCase(tab.replace(/.$/, "")) : dashedCase(tab)}`;
        },

        onTemplateChange(tab) {
            this.currentTemplateTab = tab;
        },

        /**
         * this function is called when research screen tab Change
         * @param {String} tab name of tab e.g personalDetails, keyFacts etc.
         */
        onTabChange(tab) {
            localStorage.setItem("currentTabReviewScreen", tab);
            // If current case-name not equal to params tab and current top tab is research
            if (this.$route?.params?.casename !== tab && this.fetchCurrentTopTab === "research-automated") {
                /**
                 * If mode is readOnly, it'll redirect to read only page (ro) e.g. ro/{case-id}/case/{tab}
                 * else it'll redirect to research e.g. research/{case-id}/case/{tab}
                 */
                if (this.getReadOnlyMode) this.$router.push({path: `/ro/automated/${this.$store.getters.getCaseId}/case/${tab}`}).catch(() => {});
                else this.$router.push({name: "research-automated", params: {casename: tab}}).catch(() => {});
            }

            //Reset the filters to all on tab change?
            this.filterControls.social = "All";
            this.filterControls.activePassiveMedia = "All";
            this.filterControls.associatedEntitiesFilter = "All";
            this.onChanges();

            //Scroll to top
            document.getElementById("view").scrollTo({
                top: this.scrollTop,
                behavior: "smooth",
            });
        },

        /**
         *  this function is called when top navigation tabs Change
         *   @params {String} tab  Name of the tab
         */
        async onTopTabChange(tab) {
            this.comparatorInputValue = 100;
            this.expandedAnalysisGraph = null;
            this.currentTopTab = tab;
            // If params tab name is research and not case name i.e. personalDetails or keyFacts etc
            if (tab == "research-automated" && !this.$route.params.casename) {
                /**
                 * If mode is readOnly, it'll redirect to read only page (ro)
                 * else it'll redirect to research
                 */
                // route params for casename is getting from local storage name (currentTabReviewScreen)
                this.$router.push({
                    name: this.getReadOnlyMode ? "read-only-automated" : "research-automated",
                    params: {casename: localStorage.getItem("currentTabReviewScreen")},
                });

                this.handleCaseResearchTab();
                // this.refreshData(localStorage.getItem("currentTabReviewScreen"));

                // else if current tab not equal to params tab, then only it'll redirect to params tab
            } else if (this.$route.name !== tab) {
                if (this.getReadOnlyMode && tab.includes("entities")) this.$router.push({path: `/ro/${this.getCaseId}/entities/${tab.split("-")[1]}`});
                else if (tab.includes("entities")) this.$router.push({path: `/automated/research/${this.getCaseId}/entities/${tab.split("-")[1]}`});
                else this.$router.push({name: tab});
                if (tab === "research-automated") this.refreshData(this.$route.params.casename);
            }
        },

        /**
         * this function called when clicked on expanded view of graph
         * If the mode is read only then graph will open in read only
         */
        onNavigateGraph() {
            if (this.getReadOnlyMode) this.$router.push({path: "/ro/" + this.$store.getters.getCaseId + "/case/map"}).catch(() => null);
            else this.$router.push({name: "research-automated", params: {casename: "map"}});
            this.showGraph = true;
            this.currentLocation = "map";
            this.$emit("hideOverflow", this.showGraph);
        },
        onSortByPublishedDate() {
            let sortedArray = [];
            if (this.activePassiveMediaSortingByPublishedDate === "Ascending") sortedArray = _.orderBy(this.filtered, [(obj) => new Date(obj.published_at)], ["asc"]);
            if (this.activePassiveMediaSortingByPublishedDate === "Descending") sortedArray = _.orderBy(this.filtered, [(obj) => new Date(obj.published_at)], ["desc"]);
            this.filtered = sortedArray;
        },
        onNavigateBack() {
            this.showGraph = false;
            this.currentLocation = this.currentTab;
            // location.hash = this.currentTab;
            this.$emit("hideOverflow", this.showGraph);
        },
        async onMoreDetails(card) {
            // alert(1)
            this.isPanelOpen = true;
            this.infoCard = card;
            this.panelType = "moreInfo";
            if (this.currentTab === "socialProfiles") {
                this.$store.dispatch("matchingProfile", {
                    username: card.username,
                    platform: card.platform,
                    notes: card.notes ? card.notes : "",
                    customer_notes: card.customer_notes ? card.customer_notes : "",
                });
            }
            if (this.currentTab === "keyFacts") {
                this.$router.push({
                    name: this.getReadOnlyMode ? "research-ro-automated" : this.$route.name,
                    params: {casename: this.currentTab, caseid: card._id},
                });
                this.isKeyFactLoading = true;
                const {data} = await axios.get(`/key-facts/key-fact/${card._id}`);
                // this.infoCard = data.data; // TODO uncomment
                // for testing:
                this.infoCard = {
                    ...data.data,
                    outputs: "",
                };
                this.isKeyFactLoading = false;
            }
        },
        onAddContent(card) {
            this.$store.dispatch("matchingProfile", {
                username: card.username,
                platform: card.platform,
            });
            this.$modal.show(
                ModalAddContent,
                {
                    text: "This text is passed as a property",
                    heading: "Add Content Analysis",
                    datatype: "missing",
                },
                {
                    height: "auto",
                    width: "40%",
                    scrollable: true,
                    draggable: true,
                    styles: {},
                },
                {
                    "before-close": (event) => {},
                }
            );
        },
        onShowSocialContent(card) {
            this.$store.dispatch("matchingProfile", {
                username: card.username,
                platform: card.platform,
            });
            this.$modal.show(
                ModalAllContent,
                {
                    text: "This text is passed as a property",
                    heading: "Add Content Analysis",
                    datatype: "missing",
                    card,
                },
                {
                    height: "auto",
                    width: "60%",
                    scrollable: true,
                    styles: {
                        overflow: "none",
                    },
                },
                {
                    "before-close": (event) => {},
                }
            );
        },
        onSidePanelClose() {
            if (this.currentTab === "keyFacts") {
                if (this.getReadOnlyMode) this.$router.push(`/ro/automated/${this.$store.getters.getCaseId}/case/keyFacts`);
                else {
                    this.$router.push({name: this.$route.name, params: {casename: this.currentTab}}).catch(() => {});
                    this.refreshData(this.currentTab);
                }
            }
            this.isPanelOpen = false;
            this.panelType = "trash";
        },
        onSummary() {
            this.panelType = "summary";
            this.isPanelOpen = true;
        },
        onTrash() {
            this.panelType = "trash";
            this.isPanelOpen = true;
        },
        dismiss() {
            this.addNode = false;
            // document.getElementById('backdrop').style.display = "none";
            // document.getElementById('add-cards').style.display = "none";
            // document.getElementById("main_select").value = 0;
            // this.typeChange(0);
        },

        async updateGraphEntity(event) {
            const {card, ref} = event;
            let tab;
            if (this.getSelectedEntityData.datatype === "entity") {
                tab = "personalDetails";
                await this.onPersonalDetails(card);
            } else if (this.getSelectedEntityData.datatype === "social_profile") {
                tab = "socialProfiles";
                await this.onDataChanges(card, card, tab);
            } else {
                tab = "media";
                await this.onDataChanges(card, card, tab);
            }
            this.closeMoreInfo(ref);
        },

        async updateBarEntity(event) {
            const {card, ref} = event;
            await this.onPersonalDetails(card);
            this.closeMoreInfo(ref);
        },

        async updateEntity(event, data) {
            const {card, ref} = event;
            if (this.personalDetailsTabs.includes(this.currentTab)) await this.onPersonalDetails(card);
            else await this.onDataChanges(data, card, this.currentTab);

            this.closeMoreInfo(ref);
        },

        /**
         *
         * @param {Object} card
         * @param {Object} changes
         * @param {String} currentTab
         * Update card data
         */
        async onDataChanges(card, changes, currentTab) {
            this.$store.dispatch("updateCard", {
                tab: this.currentTab,
                card,
                changes,
            });
            // this.infoCard = card
            // make an api hit to the server.

            let case_id = this.$store.getters.getCaseId;
            let tab = currentTab;

            let urlComponentTypeMap = {
                associatedPeople: {
                    url: "/entity-identifier",
                },
                socialProfiles: {
                    url: "/add-social-profile",
                },
                personalDetails: {
                    url: "",
                },
                websites: {
                    url: "/add-website",
                },
                media: {
                    url: "/save-adverse-media",
                },
                darkWeb: {
                    url: "/",
                },
                keyFacts: {
                    url: "/key-facts",
                },
            };

            let data = {};

            if (tab === "associatedPeople") {
                let id = card._id;
                let obj = {...card};
                obj.key_facts = obj?.key_facts?.map((ele) => ({key_fact_id: ele._id}));
                delete obj._id;
                obj.id = id;
                data = obj;
                data.is_collapse = card.is_collapse || false;
                data.screenshot = "screenshot" in changes ? changes.screenshot : "screenshot" in card ? card.screenshot : {available: false};
            }

            if (tab === "websites") {
                data = {
                    case_id: case_id,
                    is_collapse: false,
                    url: card.website,
                    data_type: card.type,
                    id: card._id,
                    screenshot: "screenshot" in changes ? changes.screenshot : "screenshot" in card ? card.screenshot : {available: false},
                    notes: changes.notes ? changes.notes : "",
                    customer_notes: changes.customer_notes ? changes.customer_notes : "",
                };
            }
            if (tab === "socialProfiles") {
                data = {...changes};
                data.key_facts = data?.key_facts?.map((ele) => ({key_fact_id: ele._id}));
                data.case_id = case_id;
                data.is_collapse = "is_collapse" in card ? card.is_collapse : false;
                data.id = card._id;
                delete data._id;
            }

            if (tab === "media") {
                let obj = {...changes};
                obj.key_facts = obj?.key_facts?.map((ele) => ({key_fact_id: ele._id}));
                delete obj.categories;
                data = obj;
            }

            if (tab === "keyFacts") {
                data = {...changes};
                data.outputs = changes.outputs || "";
                data.id = data._id;
                data.output_notes = changes.outputs || "";
                delete data._id;
            }
            data.status = changes.status;

            if (!("confidence_score" in changes)) delete data.confidence_score;

            try {
                await axios.put(urlComponentTypeMap?.[tab]?.["url"], data);
                this.updateChangedStatus(card, changes);
                this.$toast.success("Card updated");
                this.refreshResearchScreen();
                await this.fetchAllResearchScreenData({currentTab: "personalDetails"});
            } catch (err) {
                console.error(err);
                this.$toast.error("Can't update card");
            }
        },

        updateChangedStatus(card, changes) {
            if (changes.status === "POTENTIAL" || changes.status === "IRRELEVANT") {
                if (changes.status === "IRRELEVANT") {
                    this.pushIrrelevant({
                        case_id: this.$store.getters.getCaseId,
                        tab: ["socialProfiles", "associatedPeople", "keyFacts", "media"].includes(this.currentTab) ? this.currentTab : "personalDetails",
                        component: this.activeTab,
                        item: card,
                        type: changes.status,
                    });

                    this.onChanges();
                }

                this.popConfirmed({
                    tab: this.currentTab,
                    component: this.activeTab,
                    item: card,
                    type: changes.status,
                });
            }

            if (changes.status === "CONFIRMED")
                this.pushConfirmed({
                    tab: this.currentTab,
                    component: this.activeTab,
                    item: {...card, ...changes},
                    type: changes.status,
                });
        },

        async onPersonalDetails(card) {
            this.$store.dispatch("updateCard", {
                tab: this.currentTab,
                changes: card,
                card,
            });

            let data = {...card};
            data.key_facts = data?.key_facts?.map((el) => ({
                key_fact_id: el._id,
            }));
            data.id = data._id;
            data.is_collapse = card.is_collapse ? card.is_collapse : false;
            delete data._id;
            try {
                let response = await axios.put("/entity-identifier", data);
                if (response.status === 200 && response?.data.status) {
                    this.updateChangedStatus(card, card);
                    this.$toast.success("Card updated");
                    this.refreshResearchScreen();
                    await this.fetchAllResearchScreenData({currentTab: "personalDetails"});
                } else if (response?.data?.status) this.$toast.error("Can't update card");
            } catch (error) {
                console.error(error);
                this.$toast.error("Can't update card");
            }
        },
        onChanges() {
            //change url anchor link
            if (this.currentLocation !== "map") {
                // location.hash = this.currentTab;
                if (this.$route.params.casename !== this.currentTab && this.fetchCurrentTopTab == "research-automated")
                    this.$router.push({
                        name: "research-automated",
                        params: {casename: this.$route.params.casename},
                    });
            }
            Object.entries(this.filterControls).forEach(([k, v]) => this.setFilter({field: k, param: v}));

            // if (this.currentTab !== "personalDetails")
            this.filterData({currentTab: this.currentTab});
        },

        filterByRiskCategory() {
            // let filterValue = this.filterControls.riskCategories
            // if(filterValue.length > 1){
            //   let idx = filterValue.findIndex(e => e ==="All")
            //   this.filterControls.riskCategories.splice(idx, 1)
            // }

            this.refreshResearchScreen();
            this.onChanges();
        },

        async handelUserFilter() {
            if (!this.filterControls.selectedCaseUser.length && !this.filterControls.startDate && !this.filterControls.endDate) {
                this.$store.dispatch("setUserDocIds", []);
            } else {
                let url = `audit-log?case_id=${this.getCaseId}`;
                let data = {
                    case_id: this.getCaseId,
                    events: ["INSERT", "UPDATEONE", "UPDATE", "REPLACE"],
                    user_ids: this.filterControls.selectedCaseUser.map((user) => user.id),
                    start_date: this.filterControls.startDate,
                    end_date: this.filterControls.endDate,
                };

                try {
                    let responce = await axios.post(url, data);
                    this.$store.dispatch("setUserDocIds", responce.data.data);
                } catch (error) {
                    console.error(error);
                }
            }
        },
        onEntitySelected(event) {
            this.filterControls.entityFilter = event;
            this.refreshResearchScreen();
        },
        showContinousMonitoring() {
            window.open(`https://blackbox.neotas.uk/case/${this.$store.getters.getCaseId}`, "_blank");
        },
        openConfirmed() {
            const confirmed = this.filtered?.filter((item) => item.status === "CONFIRMED" && item.platform.toLowerCase() !== "skype");
            if (confirmed?.length)
                confirmed?.forEach((item) => {
                    let url = this.getPlatformRedirectURL(item.platform, item.entity, item.nsid);
                    window.open(url, "_blank", "noopener,noreferrer");
                });
            else this.$toast.warning("No confirmed profiles. ");
        },
        handleShowAllNotes() {
            // this.showNotes = !this.showNotes;
            sessionStorage.setItem("show-notes", this.showNotes);
        },
        handleGraphExpansion(event, flag) {
            if (event?.key && !flag) {
                this.expandedAnalysisGraph = event.val;
            } else {
                this.expandedAnalysisGraph = !this.expandedAnalysisGraph ? true : null;
            }
            if (flag) this.comparatorInputValue = this.expandedAnalysisGraph ? 0 : 100;
            else this.comparatorInputValue = this.expandedAnalysisGraph ? 0 : this.expandedAnalysisGraph == false ? 70 : 100;

            // if (this.fetchCurrentTopTab === "tools") [...document.getElementsByClassName("case-list")][0].style.padding = this.expandedAnalysisGraph ? 0 : "0 2rem";
        },
        async handleApplyFilter(event) {
            this.showNotes = event.showNotes;
            this.activePassiveMediaMonitoringCheckbox = event.activePassiveMediaMonitoringCheckbox;
            this.filterControls.status = event.filterControls.status;
            this.filterControls.rag_status = event.filterControls.rag_status;
            this.filterControls.riskCategories = event.filterControls.riskCategories;
            this.filterControls.identifiersCount = event.filterControls.identifiersCount;
            this.filterControls.identifiersMatched = event.filterControls.identifiersMatched;
            this.filterControls.identifiersInputs = event.filterControls.identifiersInputs;
            this.filterControls.identifiersTools = event.filterControls.identifiersTools;
            this.filterControls.persons = event.filterControls.persons;
            this.filterControls.locations = event.filterControls.locations;
            this.filterControls.organisations = event.filterControls.organisations;
            this.filterControls.social_platform = event.filterControls.social_platform;
            this.filterControls.media_type = event.filterControls.media_type;
            this.filterControls.categories = event.filterControls.categories;
            this.filterControls.confidenceScore = event.filterControls.confidenceScore;
            this.filterControls.selectedCaseUser = event.filterControls.selectedCaseUser;
            this.filterControls.startDate = event.filterControls.startDate;
            this.filterControls.endDate = event.filterControls.endDate;
            this.refreshResearchScreen();
            this.handelUserFilter();
            // this.filterByRiskCategory();
            this.handleShowAllNotes();
        },

        /**
         * Refresh the current tab data
         * @param {String} tab Name of the tab
         */
        async refreshData(tab) {
            this.isLoading = true;
            this.currentPage = 1;
            if (this.currentTab === "map") await this.fetchAllResearchScreenData({currentTab: "personalDetails"});
            else {
                this.$store.dispatch("fetchStaticData");
                await this.getAllResearchData({
                    tab: this.selectedResearchTab,
                    filters: this.getFilterPayload,
                });
            }

            this.allDataFetched = true;
            this.isLoading = false;

            if (document.getElementById("automation")) {
                document.getElementById("automation").addEventListener("scroll", this.onTabScroll);
                document.getElementById("automation").scrollTop += 1;
                document.getElementById("automation").scrollTop -= 1;
            }
            // if (this.$route.params.casename !== "map") this.onTabChange(tab || this.currentTab);
        },
        async onTabScroll() {
            // if view scrollTop
            if (document.getElementById("automation").scrollTop < 479) {
                this.scrollTop = document.getElementById("automation").scrollTop;
            }
            const total = this.selectedResearchTab.total_count;

            if (this.filtered?.length < total && !this.cardsLoading) {
                if (document.getElementById("automation").scrollTop > document.getElementById("automation").scrollHeight - document.getElementById("automation").offsetHeight - 100 || !this.filtered.length) {
                    await this.loadMore();
                }
            }
        },

        async loadMore() {
            this.currentPage = this.currentPage + 1;
            this.cardsLoading = true;
            await this.getAllResearchData({
                tab: this.selectedResearchTab,
                filters: this.getFilterPayload,
            });
            this.cardsLoading = false;
        },
        socialProfilesTable(list = []) {
            return `<table  class="TableGrid5" border="1" cellspacing="0" cellpadding="0" width="605" style="width:6.3in;margin-left:-.75pt;border-collapse:collapse;border:none; mso-border-alt:solid white 1.5pt;mso-border-themecolor:background1;mso-yfti-tbllook: 1184;mso-padding-alt:0in 5.4pt 0in 5.4pt;mso-border-insideh:1.5pt solid white; mso-border-insideh-themecolor:background1;mso-border-insidev:1.5pt solid white; mso-border-insidev-themecolor:background1;table-layout: fixed;"> <thead> <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes;height:39.7pt"> <td width="85" style="width:63.8pt;border:solid white 1.5pt;mso-border-themecolor: background1;background:#0070C0;padding:0in 5.4pt 0in 5.4pt;height:39.7pt"> <p class="MsoNormal" align="center" style="margin-top:6.0pt;margin-right:0in; margin-bottom:6.0pt;margin-left:0in;text-align:center"><b><span lang="EN-GB" style="mso-bidi-font-size:10.0pt;line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important; mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin; color:white;mso-themecolor:background1;">Platform<o:p></o:p></span></b></p> </td> <td width="104" style="width:77.95pt;border:solid white 1.5pt;mso-border-themecolor: background1;border-left:none;mso-border-left-alt:solid white 1.5pt; mso-border-left-themecolor:background1;background:#0070C0;padding:0in 5.4pt 0in 5.4pt; height:39.7pt"> <p class="MsoNormal" align="center" style="margin-top:6.0pt;margin-right:0in; margin-bottom:6.0pt;margin-left:0in;text-align:center"><b><span lang="EN-GB" style="mso-bidi-font-size:10.0pt;line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important; mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin; color:white;mso-themecolor:background1;">Account Provided<o:p></o:p></span></b></p> </td> <td width="416" style="width:311.85pt;border:solid white 1.5pt;mso-border-themecolor: background1;border-left:none;mso-border-left-alt:solid white 1.5pt; mso-border-left-themecolor:background1;background:#0070C0;padding:0in 5.4pt 0in 5.4pt; height:39.7pt"> <p class="MsoNormal" align="center" style="margin-top:6.0pt;margin-right:0in; margin-bottom:6.0pt;margin-left:0in;text-align:center"><b><span lang="EN-GB" style="mso-bidi-font-size:10.0pt;line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important; mso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin; color:white;mso-themecolor:background1;">Account Link<o:p></o:p></span></b></p> </td> </tr> </thead> <tbody>
            ${
                list.length > 0
                    ? list
                          .map((ele) =>
                              `
            <tr>
            <td width="85" style=" width:63.8pt;border:solid white 1.5pt;mso-border-themecolor: background1;background:#0070C0;padding:0in 5.4pt 0in 5.4pt;height:39.7pt;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;width:63.8pt;padding: 0in 5.4pt 0in 5.4pt;background: #E7E6E6;height: 40pt;"> <p style="font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important; text-align: center;font-size: 11pt;word-break: break-all;"> <img width="35" height="35" src="${
                this.$store.getters.getSocialPlatforms.find((icon) => icon.key === ele.platform).png_icon_data
            }" alt="icon" > </p> </td> <td width="104" style="border:solid white 1.5pt;mso-border-themecolor: background1;background:#0070C0;padding:0in 5.4pt 0in 5.4pt;height:39.7ptwidth:77.95pt; padding: 0in 5.4pt 0in 5.4pt;background: #E7E6E6;height: 40pt;  text-align: center;"> <p style="font-size:14.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;color: black; font-size: 14pt;word-break: break-all;">
            ${
                ele.client_provided
                    ? `<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAg9JREFUeF7tmT1KBjEQhh8rC8FWvIF4Ai0VvIqI2HsGewsRPIgItlb24gG0FARLfwh8C0HybSa7md3MJtvu7GzeZ97JJtkNKr82KtdPA9AcUDmB1gKVG6BNgq0FWgtUTqC1QOUGaF+BJbXALnAFXACfUmcvBcAO8AjsA8/ACfAhgbAEAL74TrMYgnUAzvau8nuBaj+tnPDV5wTLAEKV97XeAafAzxIBZBHvwFh0QDbxFgFkFW8NQHbxlgCoiLcCQE28BQCq4ksHoC6+ZACTiC8VwGTiSwQwqfghALaBa+ASeJdsNxNi+jY2Ls0tcAb8JuSMhqYshZ34e+AAeAWOgLfoG2QBk1e+G5YUgC++ezYXhNnES1tgC3gADgPFfAGOR7TDLLb3dUgc4GJc35+vcfNQJ8xa+dQWyA2hCPHSFvBh5XBCMeJTAXTxYyAUJX4IgDEQihM/FMAQCEWKHwMgBcK399Mi9CERnd7K1lPpUZLPYF9W9/zN6vg5FOfWCe4KndurLW9TMIwFIHHCuvHMWvnUdUAMaswJ/59X2djEBhm6n8MB0nVCF1dE5XM7wM/XNycUU3ktAH1zQlGV1wQQglCk+LHrgNic022gNiV/aWPJtO7nnAT7Jtmsx1g5YWgDyDlWlVwNgApWQ0mbAwwVS2WozQEqWA0lbQ4wVCyVoTYHqGA1lLQ5wFCxVIZavQP+AHfEiUHPn2ZGAAAAAElFTkSuQmCC"
            width="30" height="30"/>`
                    : `X`
            }
            </p> </td> <td  width="416" style="border:solid white 1.5pt;mso-border-themecolor: background1;background:#0070C0;padding:0in 5.4pt 0in 5.4pt;height:39.7pt font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;width:311.85pt;padding: 0in 5.4pt 0in 5.4pt;background: #E7E6E6;height: 40pt;" > <div style="display:block;color: #4472C4;  text-align: center;font-size: 11pt;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;word-break: break-all; "><a href="${this.$store.getters.getSocialPlatforms
                .find((icon) => icon.key === ele.platform)
                .profile_url.replace("%s", ele.entity)}" target="_blank" rel="noreferrer" style="color: #4472C4; text-decoration:none!important;display:block;"><p style="width: 414pt; word-break: break-all; font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;margin:0; text-align:center;">${ele.entity.replace("\n", "").trim()}</p>
                <br/>
                </a> </div> </td>
            </tr> `.replace("\n", "")
                          )
                          .join("")
                    : `<tr>
                    <td colspan="3" style=" font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;padding: 0in 5.4pt 0in 5.4pt;background: #E7E6E6;height: 40pt;"> <p style="text-align: center;font-size: 11pt;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important; word-break: break-all;">No information identified</p></td></tr>`
            }
            </tbody> </table>`;
        },
        keyFactsTable(list = []) {
            const categoriesList = this.options.riskCategories.find((opt) => opt.group === "Non-Risk Categories");
            return list
                .map(
                    (ele) => `
            <table class="MsoTableGrid" border="1" cellspacing="0" cellpadding="0" width="600" style="width:449.85pt;border:none;mso-border-alt: solid ${ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"} 1.5pt;border: solid ${
                        ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"
                    } 1.5pt;mso-yfti-tbllook:1184;mso-padding-alt:0in 5.4pt 0in 5.4pt; mso-border-insideh:1.5pt solid ${ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"};mso-border-insidev:1.5pt solid ${
                        ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"
                    };table-layout: fixed;"> <tbody>
            ${ele.risk_categories
                .map(
                    (ele1, index) => `${
                        index % 2 === 0
                            ? `<tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes;height:15.75pt">
                <td colspan="${ele.risk_categories.length - 1 === index ? "2" : "1"}" width="600" style="width:449.85pt;border:solid ${ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"} 0pt;background: ${
                                  ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"
                              };padding:0in 5.4pt 0in 5.4pt;height:15.75pt;${
                                  ele.risk_categories.length - 1 === index ? "" : "border-right: solid #ffffff 1.5pt;border-bottom: solid #ffffff 1.5pt;"
                              }"> <p class="MsoNormal" align="center" style="margin-top:6.0pt;margin-right:0in; margin-bottom:6.0pt;margin-left:0in;text-align:center"><b><span style="mso-bidi-font-size:11.0pt;line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important; color:white;mso-themecolor:background1;mso-ansi-language:EN-US;">${ele1}</span></b><b><span style="mso-bidi-font-size:11.0pt; line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;color:#1E293D;mso-ansi-language: EN-US;"><o:p></o:p></span></b></p> </td> ${
                                  ele.risk_categories.length - 1 === index ? "</tr>" : ""
                              }`
                            : `<td colspan="1" width="600" style="width:449.85pt;border:solid ${ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"} 0pt;background: ${
                                  ele.risk_categories.every((ele1) => categoriesList?.categories.some((ele2) => ele2.category === ele1)) ? "#0d69d5" : ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"
                              };padding:0in 5.4pt 0in 5.4pt;height:15.75pt;border-bottom: 1.5pt solid #ffffff;"> <p class="MsoNormal" align="center" style="margin-top:6.0pt;margin-right:0in; margin-bottom:6.0pt;margin-left:0in;text-align:center"><b><span style="mso-bidi-font-size:11.0pt;line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important; color:white;mso-themecolor:background1;mso-ansi-language:EN-US;">${ele1}</span></b><b><span style="mso-bidi-font-size:11.0pt; line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;color:#1E293D;mso-ansi-language: EN-US;"><o:p></o:p></span></b></p> </td></tr>`
                    }

            `
                )
                .join("")}

            <tr style="mso-yfti-irow:1;mso-yfti-lastrow:yes"> <td colspan="2" valign="top" style="width:449.85pt;border:solid ${ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"} 0.5pt; mso-border-top-alt:solid ${
                        ele.entity_status.toLowerCase() == "red" ? "#FF0000" : ele.entity_status.toLowerCase() == "amber" ? "#ffc000" : "#0d69d5"
                    } 1.5pt;padding:0in 5.4pt 0in 5.4pt"> <p class="MsoNormal" style="margin-top:6.0pt; font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;mso-bidi-font-size: 11.0pt !important;line-height:120% !important;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;mso-ansi-language:EN-US;word-break: break-all;font-family:Lato !important; font-size:11.0pt !important; text-align:justify !important;line-height:1.2 !important;"><span style="mso-bidi-font-size: 11.0pt;line-height:120%;font-size:11.0pt !important;font-family:&quot;Lato&quot;,sans-serif !important;mso-ansi-language:EN-US;word-break: break-all;font-family:Lato !important; font-size:11.0pt; text-align:justify;line-height:1.2;">${
                        ele.output_notes ? ele.output_notes : "No output found"
                    }<o:p></o:p></span></p> </td> </tr> </tbody></table>
            `
                )
                .join("</br>");
        },
        /**
         *
         * @param {String} tab
         * @param {Array} list
         */
        handleCopyToTable(tab, list = []) {
            if (tab === "media" && !list.length > 0) {
                this.handleMediaCopytoClipBoard();
            } else if (tab === "keyFacts" && !list.length > 0) {
                this.handleOtputCopytoClipBoard();
            } else {
                const el = document.createElement("div");
                if (list.length <= 0) {
                    list = this.$store.getters.getFilteredData[tab].filter((ele) => ele.status === "CONFIRMED");
                }
                let copy_temp = this[`${tab}Table`](list);
                el.innerHTML = copy_temp;
                el.setAttribute("class", "copy-clipboard");
                el.setAttribute("id", tab);
                el.style.position = "absolute";
                el.style.left = "-9999px";
                el.style.backgroundColor = "#ffffff";
                document.body.appendChild(el);
                let social_media = document.getElementById(tab);
                let range, sel;
                if (document.createRange && window.getSelection) {
                    range = document.createRange();
                    sel = window.getSelection();
                    sel.removeAllRanges();
                    try {
                        range.selectNodeContents(social_media);
                        sel.addRange(range);
                    } catch (e) {
                        range.selectNode(social_media);
                        sel.addRange(range);
                    }
                    document.execCommand("copy");
                } else if (body.createTextRange) {
                    range = body.createTextRange();
                    range.moveToElementText(social_media);
                    range.select();
                    range.execCommand("Copy");
                }
                document.body.removeChild(el);
                this.$toast.success("Copied to clipboard.");
            }
        },

        getMediaForTable(tab) {
            return this.$store.getters.getFilteredData[tab].filter((ele) => ele.status === "CONFIRMED");
        },
        async handleMediaCopytoClipBoard() {
            let el = this.$refs.clipboardTableContainer;
            el.style.display = "block";
            let range, sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(el);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(el);
                    sel.addRange(range);
                }
                document.execCommand("copy");
            } else if (body.createTextRange) {
                range = body.createTextRange();
                range.moveToElementText(el);
                range.select();
                range.execCommand("Copy");
            }

            el.style.display = "none";
            this.$toast.success("Media copy to clipboard.");
        },

        async handleOtputCopytoClipBoard() {
            let el = this.$refs.clipboardOutputTableContainer;
            el.style.display = "block";
            let range, sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(el);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(el);
                    sel.addRange(range);
                }
                document.execCommand("copy");
            } else if (body.createTextRange) {
                range = body.createTextRange();
                range.moveToElementText(el);
                range.select();
                range.execCommand("Copy");
            }

            el.style.display = "none";
            this.$toast.success("Copied to clipboard.");
        },

        getOutputForTable(tab) {
            return this.$store.getters.getFilteredData[tab].filter((ele) => ele.status === "CONFIRMED");
        },

        redirectToMoreInfo() {
            if (this.currentTab === "keyFacts") {
                this.$nextTick(() => {
                    const card = this.getResearchData?.keyFacts?.find((e) => e._id == this.$route.params.caseid);
                    if (card) this.onMoreDetails(card);
                });
            }
        },
        async socketIOConn() {
            const {VUE_APP_TAG_NAME: tagName} = process.env;
            await this.createSocketIOConn();
            //SOCKET
            this.getSocketIO.on("connect", async () => {
                this.getSocketIO.emit("begin_conn", `${this.$route.params.id}-${tagName}`);
                await this.getToolsStatus();
            });
            this.getSocketIO.on("tools-status", async (data) => {
                if (data) await this.getToolsStatus();
            });
        },

        switchResearchScreen() {
            this.$router.push(`/research/${this.getCaseId}`);
        },

        async updateProgressAndToast() {
            this.$toast.dismiss(this.toastId);
            this.toastId = null;
            this.progress = 100;

            if (this.isAnalyzerAuth) {
                const ner_data = await axios.get(`/case-analysis/${this.getCaseId}/analysis?tool=search-engine-tool`);
                this.nerRunning = !ner_data?.data?.data?.completed;
            }
            if (this.nerRunning) {
                const interval = setInterval(async () => {
                    const ner_data = await axios.get(`/case-analysis/${this.getCaseId}/analysis?tool=search-engine-tool`);
                    this.nerRunning = !ner_data?.data?.data?.completed;
                    if (!this.nerRunning) {
                        clearInterval(interval);
                        await this.refreshResearchScreen();
                        await this.fetchAllResearchScreenData({currentTab: "personalDetails"});
                        this.progress = 0;
                    }
                }, 5000);
            } else {
                await this.refreshResearchScreen();
                await this.fetchAllResearchScreenData({currentTab: "personalDetails"});
                this.progress = 0;
            }
        },

        async checkIntelligenceStatus() {
            const {data} = await axios.get(`/social-media-automation/check-status/${this.getCaseId}`);
            this.intelligenceRunning = !data?.data?.completed;
            if (!this.intelligenceRunning) {
                await this.getAllResearchTabs(this.filterControls);
                await this.updateProgressAndToast();
            } else {
                if (!this.toastId && this.toastId !== 0) {
                    this.toastId = this.$toast.info("Running Intelligence !", {
                        timeout: false,
                    });
                }
                this.progress = data?.data?.progress || 5;
                await this.getAllResearchTabs(this.filterControls);
                const interval = setInterval(async () => {
                    const {data} = await axios.get(`/social-media-automation/check-status/${this.getCaseId}`);
                    this.intelligenceRunning = !data?.data?.completed;
                    if (!this.intelligenceRunning) {
                        clearInterval(interval);
                        this.updateProgressAndToast();
                        await this.getAllResearchTabs(this.filterControls);

                        const is_unacknowledged = this.tabs?.filter((tab) => tab.unacknowledge_count)?.length ? true : false;
                        if (is_unacknowledged) this.$toast.success("Intelligence Completed");
                        else this.$toast.warning("No data found");
                    } else {
                        this.progress = data?.data?.progress || 5;
                        await this.getAllResearchTabs(this.filterControls);
                    }
                }, 5000);
            }
        },

        async refreshResearchScreen() {
            this.fetchingTabs = true;
            this.isLoading = true;
            await this.getAllResearchTabs(this.getFilterPayload);
            this.fetchingTabs = false;
            let tab = this.tabs?.[0];
            if (this.$route.params.casename) {
                tab = this.tabs.find((n) => n.key == this.$route.params.casename);
                this.handleResearchTab(tab);
            }
            this.isLoading = false;
        },

        async handleCaseResearchTab() {
            if (this.fetchCurrentTopTab === "research-automated") {
                this.listView = sessionStorage.getItem("listView") ? (sessionStorage.getItem("listView") == "true" ? true : false) : this.listView;
                this.showNotes = sessionStorage.getItem("show-notes") ? (sessionStorage.getItem("show-notes") == "true" ? true : false) : this.showNotes;

                let data = JSON.parse(sessionStorage.getItem("research-filters"));
                if (data && data.case_id === this.$store.getters.getCaseId) {
                    this.filterControls.startDate = data.st_date ? data.st_date : null;
                    this.filterControls.endDate = data.end_date ? data.end_date : null;
                    this.filterControls.status = data.status ? data.status : [];
                    this.filterControls.rag_status = data.rag_status ? data.rag_status : [];
                    this.filterControls.entityFilter = data.entity ? data.entity : [];
                    this.filterControls.selectedCaseUser = data.user ? data.user : [];
                    this.filterControls.riskCategories = data.rc ? data.rc : [];
                    this.filterControls.confidenceScore = data.confidenceScore ? data.confidenceScore : [];
                    this.filterControls.identifiersCount = data.identifiers ? data.identifiers : [];
                    this.filterControls.identifiersMatched = data.identifiersMatched ? data.identifiersMatched : [];
                    this.filterControls.identifiersInputs = data.identifiersInputs ? data.identifiersInputs : [];
                    this.filterControls.identifiersTools = data.identifiersTools ? data.identifiersTools : [];
                    this.filterControls.persons = data.persons ? data.persons : [];
                    this.filterControls.locations = data.locations ? data.locations : [];
                    this.filterControls.organisations = data.organisations ? data.organisations : [];
                    this.filterControls.media_type = data.media_type ? data.media_type : [];
                    this.filterControls.social_platform = data.social_platform ? data.social_platform : [];
                    this.filterControls.categories = data.categories ? data.categories : [];
                    this.showNotes = data.notes;
                    this.activePassiveMediaMonitoringCheckbox = data.monitoring;
                }
                await this.getAllFilterParams();
                this.checkIntelligenceStatus();
            }
        },

        async getAllFilterParams() {
            const {data} = await axios.get(`/social-media-automation/filters/${this.getCaseId}`);
            if (data?.data) {
                this.allFilterParams = data?.data;
            } else {
                this.allFilterParams = [];
            }

            const ner_categories = await axios.get(`/case-data/${this.getCaseId}/ner-categories`);
            if (ner_categories?.data) {
                this.topicCategories = ner_categories?.data;
                this.selectFilteredTopics();
            } else {
                this.topicCategories = [];
            }
        },

        switchListView(value) {
            this.listView = value;
            sessionStorage.setItem("listView", this.listView);
            document.getElementById("automation").scrollTop = 0;
        },

        toggleAllTopics(value, data) {
            if (!data) data = this.topicCategories;
            for (let item of data) {
                item.checked = value;
                if (item?.children && item?.children?.length) {
                    this.toggleAllTopics(value, item.children);
                }
            }
            this.topicCategories = JSON.parse(JSON.stringify(data));
        },

        toggleTopics(event) {
            let categories = JSON.stringify(this.topicCategories);
            let string = JSON.stringify(event.data);
            const new_string = JSON.stringify(this.toggleRecursively(event));
            categories = categories.replace(string, new_string);
            this.topicCategories = JSON.parse(categories);

            // this.topicCategories = JSON.parse(JSON.stringify(data));
        },

        toggleRecursively(event) {
            let {value, data} = event;
            for (let item of data) {
                item.checked = value;
                if (item?.children && item?.children?.length) {
                    this.toggleRecursively({
                        value,
                        data: item.children,
                    });
                }
            }

            return data;
        },

        selectFilteredTopics(items) {
            const categories = this.filterControls.categories;
            if (!items) items = this.topicCategories;
            for (const cat of categories) {
                let match;
                for (const item of items) {
                    match = this.caseInsensitiveSearch(item, cat);
                    if (match) {
                        match.checked = true;
                        break;
                    }
                }
            }
            this.topicCategories = JSON.parse(JSON.stringify(this.topicCategories));
        },

        caseInsensitiveSearch(item, searchString) {
            let match;
            match = item.category === searchString ? item : null;
            if (match) return match;
            else {
                if (item.children && item.children.length) {
                    for (const item of item.children) {
                        match = this.caseInsensitiveSearch(item, searchString);
                        if (match) return match;
                    }
                }
            }
        },
    },
};
